export default __webpack_public_path__ + "static/media/transaction.04bcc585.svg";